<template>
  <div class="">
    <el-dialog
      :title="title"
      :append-to-body="true"
       :close-on-click-modal="false"
      :visible.sync="dialogView"
      width="30%"
      :before-close="closeDialog">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model.trim="form.roleName" autocomplete="off" :disabled="!edit" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="remark">
          <el-input v-model.trim="form.remark" autocomplete="off" :disabled="!edit" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="组织类型" prop="organizationType">
          <el-radio-group :disabled="!edit" v-model="form.organizationType">
             <el-radio :label="0">管理平台</el-radio>
             <el-radio :label="2">厂商</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="viewData">
          <el-form-item label="权限信息">
            <span class="btn" v-if="editType === 'edit'" @click="showPermission" @closeView="permissionVisible = fasle">分配权限</span>
          </el-form-item>
        </div>
        <div v-if="viewData" class="menu">
          <el-tree
                :render-after-expand="false"
                  ref="tree"
                  :data="permissionList"
                  node-key="menuId"
                  :props="defaultProps">
                  <div class="centerRow" slot-scope="{ node,data }">
                    <div class="treeNodeText">
                      {{node.label}}
                    </div>
                    <div  class="childCheck">
                      <childCheck
                      :disabled="true"
                      v-if="data.buttonList && data.buttonList.length > 0"
                      :buttonList="data.buttonList">
                      </childCheck>
                    </div>
                  </div>
                </el-tree>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm" v-if="editType==='edit'">修 改</el-button>
        <el-button type="primary" @click="submitForm" v-if="editType==='add'">添 加</el-button>
      </div>
    </el-dialog>
    <roleTempPermissionView
      @closeView="permissionVisible = false &&  roleTempDetail"
      @initPermissionList="initPermissionList"
      v-if="permissionVisible"
      :ids="ids"
      :roleTempDetail="roleTempDetail"
      :permissionVisible="permissionVisible"/>
  </div>
</template>
<script>
import { updateRoleTemplate, addRoleTemplate, viewRoleTemplate, listOwnerMenu } from '@/api/auth'
import childCheck from '@/components/common/childCheck'
import roleTempPermissionView from '@/components/template/roleTempPermissionView'
import { mapGetters } from 'vuex'
export default {
  components: {
    childCheck,
    roleTempPermissionView
  },
  props: {
    dialogView: {
      type: Boolean
    },
    viewData: {
      type: Object || null
    },
    editType: {
      type: String
    }
  },
  data () {
    return {
      form: {
        roleRightGroupId: '',
        roleName: '',
        organizationType: '',
        remark: '',
        roleTemplateId: ''
      },
      rules: {
        organizationType: [
          { required: true, message: '请选择组织类型', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: '角色名不能为空', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '角色描述不能为空', trigger: 'blur' }
        ],
        roleRightGroupId: [
          { required: true, message: '请选择组织类型', trigger: 'change' }
        ]
      },
      charactorOptions: [],
      edit: false,
      permissionList: [],
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      },
      permissionVisible: false,
      roleTempDetail: null,
      ids: {
        menuIds: [], // 传递到子组件在子组件中修改
        buttonIds: []// 传递到子组件在子组件中修改
      }
    }
  },
  async created () {
    console.log('this.viewData:', this.viewData)
    this.form = Object.assign({}, this.viewData)
    if (this.editType === 'edit' || this.editType === 'add') {
      this.edit = true
    } else {
      this.edit = false
    }
    if (this.viewData) {
      await this.getTemplateDetail()
      if (this.getCacheListOwnerMenu) {
        this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
      } else {
        await this.getListOwnerMenu()
      }

      this.getShowPermission()
    }
  },
  computed: {
    ...mapGetters(['getCacheListOwnerMenu']),
    title () {
      if (this.editType === 'edit') {
        return '编辑模板'
      } if (this.editType === 'add') {
        return '添加模板'
      } else {
        return '模板信息'
      }
    }
  },
  methods: {
    async initPermissionList () {
      console.log('initPermissionList调用了')
      await this.getTemplateDetail()
      if (this.getCacheListOwnerMenu) {
        this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
      } else {
        await this.getListOwnerMenu()
      }
      this.getShowPermission()
    },
    showPermission () {
      this.permissionVisible = true
    },
    // 获取用户对应的菜单列表
    async getListOwnerMenu () {
      await listOwnerMenu().then(res => {
        res = res.data
        console.log('获取用户对应的菜单data：', res.data)
        if (res.data) {
          this.permissionList = res.data
        }
      })
    },
    getShowPermission () {
      // const showPermissionList = []
      console.log(88888)
      const menuIds = this.roleTempDetail.menuIds.join(',')
      const buttionIds = this.roleTempDetail.buttonIds.join(',')
      console.log('menuIds:', menuIds, ',buttionIds:', buttionIds)
      // 把已经有的菜单和按钮过滤出来
      function getMenu (list) {
        // list = list.filter(item => {
        //   // 这个菜单存在的情况下
        //   if (menuIds.indexOf(item.menuId) > -1) {
        //     // 按钮循环
        //     if (item.buttonList && item.buttonList.length > 0) {
        //       item.buttonList = item.buttonList.filter(btnItem => {
        //         if (buttionIds.indexOf(btnItem.buttonId) > -1) {
        //           return true
        //         }
        //       })
        //     }
        //     // 菜单循环
        //     if (item.childMenus && item.childMenus.length > 0) {
        //       getMenu(item.childMenus)
        //     }
        //     return true
        //   }
        // })

        for (var i = 0; i < list.length; i++) {
          if (menuIds.indexOf(list[i].menuId) < 0) {
            list.splice(i--, 1)
          } else {
            if (list[i].buttonList && list[i].buttonList.length > 0) {
              for (var j = 0; j < list[i].buttonList.length; j++) {
                if (buttionIds.indexOf(list[i].buttonList[j].buttonId) < 0) {
                  list[i].buttonList.splice(j--, 1)
                }
              }
            }
            // 菜单循环
            if (list[i].childMenus && list[i].childMenus.length > 0) {
              getMenu(list[i].childMenus)
            }
          }
        }
        // console.log('list:', list)
      }
      getMenu(this.permissionList)
      this.$set(this.$data, 'permissionList', this.permissionList)
      console.log('过滤后的permissionList：', this.permissionList)
    },
    async getTemplateDetail () {
      await viewRoleTemplate(this.viewData.roleTemplateId).then(res => {
        res = res.data
        console.log('角色模板信息:', res)
        this.roleTempDetail = res.data
      })
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    submitForm () {
      console.log('传递过来的数据menuIds：', this.ids.menuIds, ',this.buttonIds:', this.ids.buttonIds)
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.editType === 'edit') {
          const params = {
            roleTemplateId: this.form.roleTemplateId,
            roleRightGroupId: this.form.roleRightGroupId,
            roleName: this.form.roleName,
            remark: this.form.remark,
            organizationType: this.form.organizationType,
            menuIds: this.roleTempDetail.menuIds.join(','),
            buttonIds: this.roleTempDetail.buttonIds.join(',')
          }
          console.log('修改发送数据：', params)
          console.log(params)
          updateRoleTemplate(params).then(res => {
            res = res.data
            console.log('修改获取的信息：', res)
            if (res.code === 0 || res.code === 200) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.$emit('updateList')
              this.$emit('closeDialog')
            }
          })
        } else if (this.editType === 'add') {
          console.log(this.form)
          const params = {
            roleName: this.form.roleName,
            remark: this.form.remark,
            organizationType: this.form.organizationType
          }
          addRoleTemplate(params).then(res => {
            res = res.data
            // console.log('添加后获取的信息：', res)
            if (res.code === 0 || res.code === 200) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('updateList')
              this.$emit('closeDialog')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.btn{
  color: #409EFF;
  cursor: pointer;
}
.menu{
    .centerRow{
      display: flex;
      align-items: middle;
    }
    .childCheck{
      margin-left: 50px;
    }
    .treeNodeText{
        display: flex;
        // align-items: center;
        white-space: nowrap;
    }
    /deep/ .el-tree-node__content{
      height: auto;
      min-height: 26px;
      max-height: 200px;
      align-items: flex-start;
    }
    /deep/ .el-tree-node {
    white-space: normal;
    }
  }
</style>
